import useSWR from 'swr';

import { fetchPendingInbox } from '../data/pendingRepository.js';
import type { PendingInbox } from '../model/pendingEntry.js';

/** One key for the Home card and /cho-duyet, so an approval on one refreshes the other. */
export const PENDING_ENTRIES_KEY = 'pending-entries';

export type PendingEntriesState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; inbox: PendingInbox; refresh: () => Promise<unknown> };

export function usePendingEntries(enabled = true): PendingEntriesState {
  const { data, error, isLoading, mutate } = useSWR<PendingInbox, Error>(
    enabled ? PENDING_ENTRIES_KEY : null,
    fetchPendingInbox,
    // Rows arrive from the bank every few minutes; coming back to the app is when to look.
    { revalidateOnFocus: true, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được danh sách chờ duyệt.',
      retry: () => {
        void mutate();
      },
    };
  }
  if (isLoading || data === undefined) return { status: 'loading' };

  return { status: 'ready', inbox: data, refresh: () => mutate() };
}
